export default __webpack_public_path__ + "static/media/icones_meus_contatos.84832d37.svg";